import * as updateLib from '../api/updates';
import { getById } from '../cases/actions';
import { fetchLoadable } from '../fetchLoadable';
import * as actionTypes from './actionTypes';
export const types = () => fetchLoadable(actionTypes.FETCH_UPDATE_TYPES, updateLib.types);
export const make = (update) => {
    return updateLib.make(update).then(() => {
        getById(update.referenceId);
    });
};
//# sourceMappingURL=actions.js.map